import axios from "axios";
import { paymentGatewayApi } from "@api/instances";
import { ApiResponse } from "@api/apiRequest";
import { PaymentMethodsResponse } from "@appTypes/index";
import rollbar, { LogMetadata } from "@utils/rollbar";

const getPaymentMethods = async (signal?: AbortSignal): Promise<ApiResponse<PaymentMethodsResponse>> => {
  try {
    const response = await paymentGatewayApi.get<PaymentMethodsResponse>(
      "/v1/billing/payment-methods",
      { signal, requireAuth: true },
    );
    return { data: response.data, success: true, error: "" };
  } catch (e) {
    if (axios.isCancel(e)) {
      return { data: null, success: false, error: "AbortError" };
    }
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/v1/billing/payment-methods", method: "GET" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error fetching payment methods" };
  }
};

export default getPaymentMethods;
